<template>

  <div class="btn-group">
    <button
      class="btn btn-secondary dropdown-toggle"
      type="button" id="dropdownMenuButton"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false">
      <i class="fas fa-arrow-alt-circle-right" /> {{ $t('Move') }}
    </button>
    <div
      class="dropdown-menu"
      aria-labelledby="dropdownMenuButton">
      <a
        class="dropdown-item"
        href="javascript:void(0)"
        v-for="(item, index) in job.stages"
        :key="index"
        @click="changeStage(item._id)">
        {{ item.name }}
      </a>
    </div>
  </div>

</template>

<script>
export default {
  name: 'JobMassiveActionMove',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    candidates () {
      return this.$store.getters.getCandidateSelected
    }
  },
  created () {
  },
  methods: {
    /*
    changeStage
    */
    changeStage (stageId) {
      this.candidates.forEach((candidate) => {
        const placement = candidate.placements.find(v => v.job_id === this.job._id)
        this.$store.dispatch('movePlacement', {
          _id: placement._id,
          stage_id: stageId
        })
      })

      this.$store.dispatch('resetCandidateSelected')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobMassiveAction/JobMassiveActionMove.vue